<template>
  <b-container class="bv-example-row background" fluid>
    <div class="" style="min-height:90vh;" v-show="kingloading">
      <div class="content">
        <div class="kingloader"><b-spinner style="width: 4rem; height: 4rem;color: #fff !important;" variant="primary" label="Text Centered"></b-spinner></div>
      </div>
    </div>
    <div v-if="message != ''">
      <div class="row" style="min-height:30vh">
        <div v-show="$mainDomain == 'Wynum'" class="offset-md-1 col-md-7 mainheader" style="margin-top:10vh;font-size:6vh;font-family:inherit">
            {{$mainDomain}}
        </div>
        <div v-show="$mainDomain != 'Wynum'" class="offset-md-1 mainheader" style="margin-top:2vh;font-size:6vh;font-family:inherit">
            <img :src="getImgUrl()" style="height:18vh;width:18vw">
        </div>
      </div>
      <div class="row">
        <div class="offset-md-1 col-md-11 mainsubheader1" style="min-height:6vh">
          {{message}}
        </div>
        <div class="offset-md-1 col-md-6">
          <div class="form-group" style="text-align:left;">
            <button @click="loginpage()" class="btn home-orange-btn" style="cursor:pointer">Try Again</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="min-height:5vh">
        <div class="bottom_image"></div>
    </div>
  </b-container>
</template>

<script>
//require('@/assets/css/login.css')
import axios from 'axios'
import { EventBus } from '../event-bus.js'

export default {
  name: 'Auth_success',
  data () {
    return {
      userid: '',
      error: '',
      password: '',
      auth_token: '',
      message: false,
      title: '',
      showconfirm : '',
      code:'',
      codemessage:false,
      kingloading : true,
    }
  },
  created (){
    console.log(this.$route.query.code)
    console.log(this.$route.query.session_state)
    this.getToken(this.$route.query.code, this.$route.query.session_state)
  },
  mounted () {
    console.log("hello", new Date())
  },
  computed: {
    isDisabled () {
      if (this.userid !== '') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    getToken(code, state){
      axios.post('/microsoftToken?code=' + code+ "&state="+state)
        .then(res => {
          this.kingloading = false
          if (res.data.value !== null && res.data.value !== 1 && res.data.value !== 0) {
              localStorage.setItem('authtoken', res.data.Token)
              axios.defaults.headers.common['Authorization'] = res.data.Token
              this.$connect(this.$socketUrl + '?token='+res.data.Token)
              this.$router.push('/Dashboard')
              EventBus.$emit('login', res.data.Token)
          } else if (res.data.value === 0) {
            this.showconfirm = true
            //this.$router.push('/Confirm')
          } else {
            this.error = true
            this.message = "There seems to be an issue with completing the OAuth process. Please try again."
            console.log(res.data.error)
            //this.ShowToast("Error", "User not found.", "default")
          }
        }
      )
    },
    getImgUrl() {
      var images = require.context('../assets/', false, /\.png$/)
      return images('./' + this.$mainDomain + ".png")
    },
    passwordpage () {
      this.$router.push('/ForgotPassword')
    },
    loginpage(){
      this.$router.push('/')
    },
    ShowToast(header, body, color){
      this.$bvToast.toast(body, {
      title: header,
      variant: color,
      solid: true,
      toaster: 'b-toaster-bottom-center'
      })
    },
    onEnterEmail(e){
      if (e.keyCode === 13) {
        this.sendconfirm()
      }
    },
    onEnterCode(e){
      if (e.keyCode === 13) {
        this.confirm()
      }
    }
  }
}
</script>

<style scoped>
    @font-face {
        font-family: Lato;
        src: url('//fonts.googleapis.com/css?family=Lato');
    }
.mainbox {
    height: auto;
    background-image: linear-gradient(136deg, #86c6fa, #596cd5, #496cae, #1c4491);
  }
  .loginbox {
    background-color: #f5f6fb
  }
  .btn-login-google {
      border-radius: 25px;
      border: solid 2px white;
      background-color: white;
      color:#0393f6;
      font-size: large;
      width: 100%;
      height: 50px;
      font-size:larger;
      display: initial;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
  }
  .btn-login {
      border-radius: 25px;
      border: solid 2px #0393f6;
      background-color: #0393f6;
      color:white;
      width: 147px;
      height: 50px;
      font-size:larger;
      display: initial
  }
  
  .btn-header{
      border-radius: 25px;
      border: solid 2px #4427d7;
      background-color: #4427d7;
      color:white;
      height: 50px;
      font-size:larger;
  }
  
  .btn-toggle{
      border-radius: 20.5px;
      background-color: #4427d7;
  }
  
  .list-inline-item:not(:last-child) {
      margin-right: 1rem;
  }
  
  .card-title{
      font-size: 1.7vw;
      text-align: left;
  }
  
  .card-body{
      text-align: center;
  }
  
  .card-text{
      text-align: left;
      font-size: 1.1vw;
  }
    
  .form-label-group {
      position: relative;
      margin-bottom: 1rem;
      border-radius: 10px;
      padding: 3vh;
      font-size: 1vw;
  }
    
  .form-label-group>input,
    .form-label-group>label {
      padding: 20px;
      height: auto;
      border-radius: 10px;
  }
    
  .form-label-group>label {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      margin-bottom: 0;
      /* Override default `<label>` margin */
      line-height: 1.5;
      color: #495057;
      cursor: text;
      /* Match the input under the label */
      border: 1px solid transparent;
      border-radius: .25rem;
      transition: all .1s ease-in-out;
  }
    
  .form-label-group input::-webkit-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input:-ms-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input::-ms-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input::-moz-placeholder {
      color: transparent;
  }
  
  .form-label-group input::placeholder {
      color: transparent;
  }
    
  .form-label-group input:not(:placeholder-shown) {
      padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
      padding-bottom: calc(var(--input-padding-y) / 3);
  }
    
  .form-label-group input:not(:placeholder-shown)~label {
      padding-top: calc(var(--input-padding-y) / 3);
      padding-bottom: calc(var(--input-padding-y) / 3);
      font-size: 12px;
      color: #777;
  }
  
  .register .nav-tabs{
      width: 16vw;
      height: 2.5vw;
      background-color: #e7e8f0;
      border-radius: 1.5rem;
      float: right;
  }
  .register .nav-tabs .nav-link{
      font-size: 1vw;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #596cd5;
  }
  .register .nav-tabs .nav-link:hover{
      border: none;
  }
  .register .nav-tabs .nav-link.active{
      width: 9vw;
      height: 2.5vw;
      object-fit: contain;
      border-radius: 20.5px;
      background-color: #596cd5;
      border: solid 2px #596cd5;
      color: #ffffff
  }
  .register-heading{
      text-align: center;
      margin-top: 8%;
      margin-bottom: -15%;
      color: #495057;
  }
  
  .register-main-text {
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.34);
      font-size: 2.9vw;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.36;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
  }
  
  .register_sub_text {
      font-size: 1.2vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.62;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
  }
  .home-orange-btn{
    background-color: #f16621 !important;
    color: white !important;
    text-transform: uppercase !important;
    border-radius: 5px !important;
    padding: 1.3vh !important;
    font-size: 2vh !important;
    font-weight: 500 !important;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.34) !important;
    line-height: 1.5 !important;
  }
  
  footer {
    position: fixed;
    bottom:0;
  }
    .background{
        background-image: url("../assets/background1.png");
        object-fit: cover;
        background-repeat: no-repeat;
        background-size: 100%;
        min-height: 100vh;
    }
    .bottom_image{
        background-image: url("../assets/bottom.png");
        height: 2vh;
        width: 100vw;
        position: fixed;
        bottom: 0;
    }
    .mainheader{
        font-family: Lato;
        font-size: 9.5vh;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.96;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
    }
    .mainsubheader1{
        font-family: Lato !important;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.65;
        letter-spacing: 1px;
        text-align: left;
        color: #ffffff;
        margin-top:2vh;
    }
    .link{
        cursor: pointer;
    }
</style>

